module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].contact))]), _c('hr'), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _c('div', {
    staticClass: "addr"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].addressBeijing))])]), _vm._m(0)]), _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _c('div', {
    staticClass: "addr"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].addressShanghai))])]), _vm._m(1)])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].follow))]), _c('hr'), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(_vm._s(_vm.langs[_vm.lang].bp)), _c('br'), _vm._v("bp@bertelsmann.com")]), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(_vm._s(_vm.langs[_vm.lang].join)), _c('br'), _vm._v("hr@bertelsmann.com")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("+86 10 6563 0026")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("+86 21 6418 7585")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ed2b66","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 508
// module chunks = 1